<template>
  <div class="sidebar" :style="{width: collapsed?'150px':'44px'}">
    <a-menu
        mode="inline"
        :selectedKeys="[store.state.fullPath]"
        :inline-collapsed="!collapsed"
    >
      <template v-for="item in list" :key="item.path">
        <a-menu-item  @click="handelClick(item)">
          <template #icon>
            <icon-font :type="item.icon" />
          </template>
          {{$t(item.title)}}
        </a-menu-item>
      </template>
    </a-menu>
    <p @click="goUrl" class="version" :style="[{padding:!collapsed?'0px':'',textAlign:!collapsed?'center':''}]">
      <i class="iconfont icon-info"></i>
      <span style="margin-left: 6px;" v-if="collapsed">
        {{$t('版本记录')}}
      </span>
    </p>
    <p @click="collapseChange" v-if="collapsed" class="icon m-0 mb-0">
      <span>
          <img src="../assets/left_arr.png">
           <span class="ml-10">{{ $t('main.b1') }}</span>
        </span>
    </p>
    <p @click="collapseChange" v-else class="icon">
      <span>
          <img src="../assets/right_arr.png">
      </span>
    </p>
  </div>
</template>
<script>
import { defineComponent, ref, computed,watch } from 'vue';
import { useRoute,useRouter } from 'vue-router'
import { useStore } from "vuex";
import { createFromIconfontCN } from '@ant-design/icons-vue';

const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_3441417_jtp20ctantg.js',
});
import {getUserInfo, getRouters} from "@/store/cache.js"
export default defineComponent({
  components: {
    IconFont
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const headObjectName = ref('');
    const user = getUserInfo();

    const VUE_APP_BASE_API = computed(()=>{
      return process.env.VUE_APP_BASE_API
    })
    // const list = [
    //   {
    //     title:'版本记录',
    //     key:'/logs',
    //     icon:'icon-duanxin',
    //   },{
    //     title:'系统总览',
    //     key:'/dashboard',
    //     icon:'icon-shouyefill',
    //   },{
    //     title:'用户管理',
    //     key:'/user',
    //     icon:'icon-zhanghubaobiao',
    //   },{
    //     title:'用户反馈',
    //     key:'/feedback',
    //     icon:'icon-suijiyonghu',
    //   },{
    //     title:'系统设置',
    //     key:'/setting',
    //     icon:'icon-shezhi',
    //   }
    // ]
    const list = getRouters() ? JSON.parse(getRouters()) : [];

    const handelClick = (item) =>{
      if (item.path !== route.path) {
        router.push(item.path)
      }
    }

    const fileList = ref([]);

    const screenWidth = ref(null);

    //侧边栏伸缩
    const collapsed = computed(() => store.state.collapse);

    window.addEventListener('resize', () => {
      screenWidth.value = document.body.clientWidth
    })

    watch(screenWidth,(e)=>{
      if(e < 978){
        store.commit('handleCollapse',false);
      }else {
        store.commit('handleCollapse',true);
      }
    })
  // 侧边栏折叠
    const collapseChange = () => {
      store.commit("handleCollapse", !collapsed.value);
    };

    const goUrl = () => {
      router.push('/logs')
    }
    return {
      store,
      collapsed,
      list,
      handelClick,
      route,
      router,
      fileList,
      user,
      VUE_APP_BASE_API,
      headObjectName,
      collapseChange,
      goUrl
    };

  },
});
</script>
<style scoped lang="less">
.sidebar{
  position: relative;
  z-index: 10;
  height: 100%;
  text-align: center;
  background: #fafafa;
  overflow: hidden;
  .img{
    width: 40%;
  }
}
// 设置菜单样式
.ant-menu,.ant-menu-sub,.ant-menu-inline{
  color: #707070;
  background-color: #fafafa !important;
}
//去掉右边框
.ant-menu-inline {
  border: none;
  margin: 0px;
}
/deep/.ant-menu-inline.ant-menu-root .ant-menu-item{
  height: 56px!important;
  border: 0;
  padding: 0;
  //border-bottom: 1px solid #435b64;
}
/deep/.ant-menu.ant-menu-inline-collapsed > .ant-menu-item{
  padding: 0 20px!important;
}
/deep/.ant-menu-item:hover{
  background: #f0f0f0;
  color: #707070;
  border: 0;
}
/deep/.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected:hover{
  color: #0aa491;
}
/deep/.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected:after{
  border: 0;
}
/deep/.ant-menu-inline.ant-menu-root .ant-menu-item:active{
  color: #0aa491;
  border: 0;
}
/deep/.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected{
  color: #0aa491;
  border: 0!important;
  background: #f0f0f0;
}
/deep/.ant-menu.ant-menu-inline-collapsed{
  width: 44px;
  .ant-menu-item{
    padding: 0 12px!important;
  }
}
/deep/.ant-menu.ant-menu-inline .ant-menu-item{
  padding-left: 18px!important;
}
/deep/.ant-menu-item{
  margin: 0!important;
  line-height: 56px!important;
  height: 56px!important;
  text-align: center!important;
}
/deep/.ant-menu-item-icon{
  margin-left: 1px!important;
  font-size: 16px!important;
}
.version{
  width: 100%;
  padding-left: 18px;
  position: absolute;
  text-align: left;
  bottom: 55px;
  left: 0;
  color: #707070;
  cursor: pointer;
}
.icon {
  width: 100%;
  text-align: center;
  padding: 10px 0;
  position: absolute;
  bottom: 0;
  color: #707070;
  transition: all 0s;
  margin-bottom: 0;
  >span{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    width: fit-content;
    height: 30px;
    padding-left: 16px;
  }
  img{
    width: 12px;
    height: 12px;
  }
}
.icon:hover{
  background-color: rgba(0, 0, 0, 0.04);
  transition: all 0.5s;
}
/deep/.ant-menu-title-content{
  text-align: left!important;
}
.ml-10{
  margin-left: 10px;
}
</style>
